import * as Stimulus from "@hotwired/stimulus"

const MIDDAY = 3600 * 12
export class TimeInputController extends Stimulus.Controller {
    static get targets() {
        return ['input', 'selectContainer'];
    }

    static values = {
        default: String
    }

    static classes = ['select']

    connect() {
        if (!this.inputTarget.value) {
            this.inputTarget.value = this.defaultValue;
        }
        const initialValue = this.#parseTimeFormat(this.inputTarget.value);
        this.#initializeSelectContainer(initialValue);
    }

    disconnect() {
        if (this.hasSelectContainerTarget) {
            this.selectContainerTarget.replaceChildren();
        }
    }

    updateInput() {
        let newValue = +this.$timeSelect.value
        if (this.$amPmSelect.value == 'PM') {
            newValue += MIDDAY
        }
        this.inputTarget.value = this.#renderTimeString24hr(newValue);
    }

    #initializeSelectContainer(initialValue) {
        this.$timeSelect = document.createElement('select');
        this.$timeSelect.classList.add(...this.selectClasses);
        for (let i = 0; i < MIDDAY; i += +this.inputTarget.step) {
            let option = document.createElement('option');
            option.value = i;
            if (option.value == initialValue % MIDDAY) {
                option.selected = true;
            }
            option.innerText = this.#renderTimeString12hr(i);
            this.$timeSelect.appendChild(option);
        }

        let $amOption = document.createElement('option');
        $amOption.value = "AM";
        $amOption.innerText = "AM";
        $amOption.selected = initialValue < MIDDAY;

        let $pmOption = document.createElement('option');
        $pmOption.value = "PM";
        $pmOption.innerText = "PM";
        $pmOption.selected = initialValue >= MIDDAY;

        this.$amPmSelect = document.createElement('select');
        this.$amPmSelect.classList.add(...this.selectClasses);
        this.$amPmSelect.appendChild($amOption);
        this.$amPmSelect.appendChild($pmOption);

        this.selectContainerTarget.replaceChildren(this.$timeSelect, this.$amPmSelect);
    }

    #parseTimeFormat(timeString) {
        let parts = timeString.split(':');
        let res = (parseInt(parts[0], 10) * 3600) + (parseInt(parts[1], 10) * 60);
        if (parts.length > 2) {
            res += parseInt(parts[2], 10);
        }
        return res;
    }

    #renderTimeString24hr(value) {
        return formatTimeString(value, { hour12: false })
    }

    #renderTimeString12hr(value) {
        return formatTimeString(value, { hour12: true })
    }
}

function formatTimeString(value, options) {
    let hours;
    if (options.hour12) {
        hours = (Math.floor(value / 3600) % 12) || "12";
    } else {
        hours = String(Math.floor(value / 3600)).padStart(2, '0');
    }
    const minutes = String(Math.floor((value % 3600) / 60)).padStart(2, '0');
    const seconds = value % 60
    if (seconds > 0) {
        const paddedSeconds = String(seconds).padStart(2, '0');
        return `${hours}:${minutes}:${paddedSeconds}`;
    } else {
        return `${hours}:${minutes}`;
    }
}
